"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechToSpeechStreamRequestFileFormat = void 0;
exports.SpeechToSpeechStreamRequestFileFormat = {
    PcmS16Le16: "pcm_s16le_16",
    Other: "other",
};
